<template>
  <v-app>
    <SiteHeader :vertical="currentVertical" />
    <v-main>
      <router-view />
    </v-main>
    <SiteFooter :vertical="currentVertical" />
  </v-app>
</template>

<script>
import SiteHeader from './components/shared/SiteHeader.vue';
import SiteFooter from './components/shared/SiteFooter.vue';

export default {
  name: 'App',
  components: {
    SiteHeader,
    SiteFooter,
  },
  computed: {
    currentVertical() {
      return this.$route.meta.vertical || 'hub';
    },
  },
};
</script>

<style lang="scss">
/* Smooth scroll */
html {
  scroll-behavior: smooth;
}

/* Button animations */
.v-btn {
  transition: all 0.3s ease;
}

.v-btn:hover {
  transform: translateY(-2px);
}
</style>
